import React, { useEffect, useState } from 'react';
import {  useNavigate } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';

import { API_URL } from '../../components/constant.js'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReCAPTCHA from "react-google-recaptcha";




function ChcLogin() {

  /******************************** */
  const navigat = useNavigate();
  const isLogin = reactLocalStorage.get('isLogin');
  useEffect(() => {
    if (isLogin) {
      return navigat('/dashboard')

    }
    document.title = 'Login';
  });


  /********************disable enable************************* */

  const [disDiv, setDisDiv] = useState(false);


const [captchaToken, setCaptchaToken] = useState(null);
const [captchaError, setCaptchaError] = useState(false);

const onCaptchaChange = (token) => {
  setCaptchaToken(token);
  setCaptchaError(false);
};

  /*************Submit******************** */

  let doLogin = async (e) => {
    setDisDiv(true);
    e.preventDefault();
     if (!captchaToken) {
    setCaptchaError(true);
     setDisDiv(false);
    return;
  }
    if (validate(e)) {
      const data = new FormData(e.target);
      let formData = {
        'mobile': data.get('mobile'),
        'password':btoa(data.get('password')),
        'token':captchaToken

      };
   

      const regData = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      }
      const getResp = await fetch(API_URL + 'chc/login', regData);
      const getdatas = await getResp.json();

    
      if (getdatas.status == '200') {
        reactLocalStorage.set('isLogin', true);
        reactLocalStorage.set('user_id', getdatas.res_data.user_id);
        reactLocalStorage.set('user_email', getdatas.res_data.mobile_no);

        if (getdatas.res_data.user_type == 'hospital') {
          reactLocalStorage.set('user_name', getdatas.res_data.chc_name);
          reactLocalStorage.set('chc_phc', getdatas.res_data.chc_phc_id);
          reactLocalStorage.set('block', getdatas.res_data.block_id);
          reactLocalStorage.set('district', getdatas.res_data.district_id);
          reactLocalStorage.set('userType', getdatas.res_data.chc_phc_id);  /// for block use block_id,for district user district_id
          reactLocalStorage.set('userLoginType', "Chc");         //Chc //Block//District

          setDisDiv(false);
          return navigat('/dashboard');

        }
        if (getdatas.res_data.user_type == 'block') {
          reactLocalStorage.set('user_name', getdatas.res_data.block_name);
          reactLocalStorage.set('chc_phc', "");
          reactLocalStorage.set('block', getdatas.res_data.block_id);
          reactLocalStorage.set('district', getdatas.res_data.district_id);
          reactLocalStorage.set('userType', getdatas.res_data.block_id);  /// for block use block_id,for district user district_id
          reactLocalStorage.set('userLoginType', "Block");         //Chc //Block//District

          setDisDiv(false);
          return navigat('/dashboard');

        }
        if (getdatas.res_data.user_type == 'district') {
          reactLocalStorage.set('user_name', getdatas.res_data.district_name);
          reactLocalStorage.set('chc_phc', "");
          reactLocalStorage.set('block', "");
          reactLocalStorage.set('district', getdatas.res_data.district_id);
          reactLocalStorage.set('userType', getdatas.res_data.district_id);  /// for block use block_id,for district user district_id
          reactLocalStorage.set('userLoginType', "District");         //Chc //Block//District

          setDisDiv(false);
          return navigat('/dashboard');

        }
        if (getdatas.res_data.user_type == 'store') {

          let formData = {
            "state_id": getdatas.res_data.state_id,
            "district_id": getdatas.res_data.district_id,
            "block_id": getdatas.res_data.block_id,
            "chc_id": getdatas.res_data.chc_phc_id,
          };
         

          const regData = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
          }
          const getRespss = await fetch(API_URL + 'chc/getHospitalStore', regData);
          const getdatass = await getRespss.json();
        

          if (getdatass.status == '200') {
            reactLocalStorage.set('user_id', getdatass.Rdata[0].user_id);
            reactLocalStorage.set('user_name', getdatass.Rdata[0].chc_name);
            reactLocalStorage.set('chc_phc', getdatass.Rdata[0].chc_phc_id);
            reactLocalStorage.set('block', getdatass.Rdata[0].block_id);
            reactLocalStorage.set('district', getdatass.Rdata[0].district_id);
            reactLocalStorage.set('userType', getdatass.Rdata[0].chc_phc_id);  /// for block use block_id,for district user district_id
            reactLocalStorage.set('userLoginType', "Store");         //Chc //Block//District
            navigat('/my_inventory_req');
            setDisDiv(false);
            //return navigat('/dashboard');

          } else {

           // notify("Please Create CHC/SDH/DH");
            notify("Invalid Credentials");
            setDisDiv(false);

          }
        }

        if (getdatas.res_data.user_type == 'districtStore') {

          let formData = {
            "state_id": getdatas.res_data.state_id,
            "district_id": getdatas.res_data.district_id,
            "block_id": getdatas.res_data.block_id,
            "chc_id": getdatas.res_data.chc_phc_id,
          };
         

          const regData = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
          }
          const getRespss = await fetch(API_URL + 'chc/getDistrictStoreDatas', regData);
          const getdatass = await getRespss.json();
       

          if (getdatass.status == '200') {
            reactLocalStorage.set('user_id', getdatass.Rdata[0].user_id);
            reactLocalStorage.set('user_name', getdatass.Rdata[0].district_name);
            reactLocalStorage.set('chc_phc', "");
            reactLocalStorage.set('block', "");
            reactLocalStorage.set('district', getdatass.Rdata[0].district_id);
            reactLocalStorage.set('userType', getdatass.Rdata[0].district_id);  /// for block use block_id,for district user district_id
            reactLocalStorage.set('userLoginType', "DistrictStore");         //Chc //Block//District
            navigat('/my_inventory_req');
            setDisDiv(false);
            //return navigat('/dashboard');

          } else {

           // notify("Please Create District User");
           notify("Invalid Credentials");
            setDisDiv(false);

          }
        }  

      } else {

       // notify("Wrong Username/Password");
       notify("Invalid Credentials");
        setDisDiv(false);
      }


    }

  }
  /**************Validation************************* */
  let validate = (ev) => {
    const data = new FormData(ev.target);
   
    let validat = true;
    if (data.get('mobile') == '') {
      notify('Please enter mobile no. ');
      validat = false;
    } else {
      let mobRegExp = "^[0-9]{10}";
     
      let mobname = data.get('mobile').match(mobRegExp);
      if (mobname) {
        return validat = true;
      } else {
        notify('Please enter valid mobile no.');
        return validat = false;
      }
    }
  }
  /*********************Toast****************************** */
  const notify = (e) => toast(e);
  /******************************************************* */

  return (
    <>
      <ToastContainer />
      <div className="container-scroller">
        <div className="container-fluid page-body-wrapper full-page-wrapper">
          <div className="content-wrapper d-flex align-items-center auth px-0">
            <div className="row w-100 mx-0">
              <div className="col-lg-4 mx-auto">
                <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                  <div className="brand-logo" style={{ "textAlign": "center" }}>
                    <img src={process.env.PUBLIC_URL + "/images/logo.png"} alt="logo" style={{ "width": "65px" }} />
                  </div>
                  <h4>T4 User Login</h4>
                  <h6 className="font-weight-light">Sign in to continue.</h6>
                  <form className="pt-3" onSubmit={doLogin}>
                    <div className="form-group">
                      <input type="tel" 
                             name="mobile" 
                             autoComplete='off' 
                             pattern='[6789][0-9]{9}' 
                             maxLength={10} 
                             className="form-control form-control-lg" 
                             id="exampleInputEmail1" 
                             placeholder="Mobile Number" 
                             required
                             onCopy={(e) => e.preventDefault()}
                             onPaste={(e) => e.preventDefault()}
                             onCut={(e) => e.preventDefault()}
                            />

                    </div>
                    <div className="form-group">
                      <input type="password"
                             name="password" 
                             autoComplete='off' 
                             className="form-control form-control-lg" 
                             id="exampleInputPassword1" 
                             placeholder="Password" 
                             required 
                             onCopy={(e) => e.preventDefault()}
                             onPaste={(e) => e.preventDefault()}
                             onCut={(e) => e.preventDefault()}
                             pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                             title="Must contain at least 8 characters, including 1 uppercase, 1 lowercase, 1 number, and 1 special character"
                             />
                    </div>
                         {/* 🔐 GOOGLE CAPTCHA */}
                    <div className="form-group">
                      <ReCAPTCHA
                        // sitekey="6Le9KUosAAAAANsHgIdvntiktiK8e1fsmgyMqkcP"
                        sitekey="6LeCwforAAAAANZkuTWimqVM_M2NkEO124-ZjiNE"
                        onChange={onCaptchaChange}
                      />
                      {captchaError && (
                        <small className="text-danger">
                          Please verify captcha
                        </small>
                      )}
                    </div>
                    <div className="mt-3">
                      <button type="submit" id="btn" className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" disabled={disDiv}  >SIGN IN</button>
                    </div>
                    <div className="my-2 d-flex justify-content-between align-items-center">
                    
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </>
  );
}

export default ChcLogin;